<template>
  <div>
    <NavHeader></NavHeader>
    <div class="bodyClass">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import NavHeader from "./components/NavHeader";
import Footer from "./components/Footer";

export default {
  name: "LayoutIndex",
  components: { NavHeader, Footer }
}
</script>

<style scoped>

.bodyClass {
  min-height: 70vh;
  background-color: #F3F9FD;
}

</style>